const userProfile = {
  pageTitle: 'Meu perfil',
  toast: {
    success: 'Perfil atualizado com sucesso.',
    error: 'Ocorreu um erro desconhecido.',
  },
  tabs: {
    personalInfo: 'Informação pessoal',
    security: 'Garantia',
  },
  form: {
    personalDetails: {
      notice: 'Nota: algumas informações podem ser visualizadas por outras pessoas que estejam utilizando os serviços Moovex.',
      title: 'Detalhes pessoais',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      email: 'E-mail',
      phone: 'Telefone',
      gender: 'Sexo',
      genderOptions: {
        male: 'Masculino',
        female: 'Feminino',
        default: 'Preferencialmente não dizer / Outra',
      },
      dateOfBirth: 'Data de nascimento',
    },
    preferences: {
      title: 'Preferências',
      twoFactorAuth: 'Autenticação de dois fatores (2FA)',
      twoFactorAuthWarning: 'Ao salvar esta configuração, você poderá ser desconectado do sistema, sendo necessário um novo login.',
      twoFactorAuthNotice: 'A autenticação de dois fatores (2FA) é requerida pela política do local e não pode ser desabilitada.',
      twoFactorAuthInfo: 'O acesso a locais com aplicação de 2FA pode substituir esta preferência.',
    },
    userRoles: {
      title: 'Funções de usuário',
      companyAdmin: 'Administrador de empresa',
      site: 'Local',
      role: 'Função',
    },
    update: 'Atualizar',
  },
  validations: {
    firstName: 'Nome é obrigatório',
    lastName: 'Sobrenome é obrigatório',
    phone: {
      invalid: 'O telefone é inválido',
      required: 'O telefone é obrigatório',
      length: 'O telefone deve conter de 6 a 16 dígitos',
    },
    email: {
      required: 'E-mail é obrigatório',
      email: 'Endereço de e-mail inválido',
    },
  },
};

export default userProfile;
